import React from "react";
import "../../../styles/customize-components/form-btns.css";

const CloseSubmitBtn = ({
  closeLabel = "Cancel",
  submitLabel = "Submit",
  onClose,
  onSubmit,
  isLoading = false,
  isSubmitDisabled,
}) => {
  return (
    <div className="button-container">
      {onClose && (
        <button
          type="button"
          className="btn btn-outline-dark close-btn"
          onClick={onClose}
          disabled={isLoading}
        >
          {closeLabel}
        </button>
      )}

      {onSubmit && (
        <button
          type="button"
          className="btn btn-danger submit-btn"
          onClick={onSubmit}
          disabled={isLoading || isSubmitDisabled}
          style={{
            opacity: isSubmitDisabled ? 0.5 : 1,
            cursor: isSubmitDisabled ? "not-allowed" : "pointer",
          }}
        
      >
          {submitLabel}
        </button>
      )}
    </div>
  );
};

export default CloseSubmitBtn;
